<div
  data-cy="decimal-quantity-section"
  id="quantity-input"
  [class.product-card]="isProductCard"
  [ngClass]="[
    (platformService?.isTouchExperience$ | async) ? 'touch' : 'desktop',
    !isDisabled ? 'enabled' : 'disabled',
  ]"
  [class.warn]="
    customBorder === borderRef.warning && platformService?.isTouchExperience$
      | async
  "
  [class.caution]="
    customBorder === borderRef.caution && platformService?.isTouchExperience$
      | async
  "
  [class.help]="
    customBorder === borderRef.helpful && platformService?.isTouchExperience$
      | async
  "
>
  <ion-icon
    *ngIf="!isDisabled && platformService?.isTouchExperience$ | async"
    id="{{ isEaches ? 'each-' : 'case-' }}decrement-{{ index }}"
    name="remove-outline"
    (click)="decrementQuantity(productNumber, itemInput?.value)"
    data-cy="click-decrement-quantity-button"
  ></ion-icon>
  <ion-input
    data-cy="product-quantity-input"
    id="{{ id }}"
    [class.hide]="isDisabled"
    disabled="{{ !(productNumber > 0) || isDisabled }}"
    globalkeyhandler="quantityInput"
    inputmode="decimal"
    placeholder="{{
      (platformService?.isTouchExperience$ | async) === false && isDisabled
        ? null
        : 0
    }}"
    [value]="quantity?.currentValue > 0 ? quantity.currentValue : null"
    (ionBlur)="changeQuantity(productNumber, $event)"
    (keyup.enter)="changeQuantity(productNumber, $event)"
    [maxLeftHandDigits]="4"
    [maxPrecision]="2"
    customDecimal
    #itemInput
    [class.warn]="customBorder === borderRef.warning"
    [class.caution]="customBorder === borderRef.caution"
    [class.help]="customBorder === borderRef.helpful"
  ></ion-input>
  <!-- swap out inputs when disabled -->
  <ion-input
    data-cy="product-quantity-input"
    class="not-applicable"
    [class.hide]="!isDisabled"
    [class.warn]="customBorder === borderRef.warning"
    [class.caution]="customBorder === borderRef.caution"
    [class.help]="customBorder === borderRef.helpful"
    disabled="true"
    placeholder="{{ 'i18n.common.notApplicable' | translate }}"
  ></ion-input>

  <ion-icon
    *ngIf="!isDisabled && platformService?.isTouchExperience$ | async"
    id="{{ isEaches ? 'each-' : 'case-' }}increment-{{ index }}"
    name="add-outline"
    (click)="incrementQuantity(productNumber, itemInput?.value)"
    data-cy="click-increment-quantity-button"
  ></ion-icon>
</div>
